import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import vensoRepository from "@/services/VensoRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export default class DownloadControlDocument extends AbstractCommand {
    orderId;
    orderNumber;
    constructor(orderId, orderNumber) {
        super();
        this.orderId = orderId;
        this.orderNumber = orderNumber;
    }
    async execute() {
        try {
            const dto = await vensoRepository.downloadControlDocument(this.orderId, this.orderNumber);
            alerts.success(trans('venso_delivery_receipt.download_control_document'));
            return dto;
        }
        catch (e) {
            alerts.error(trans(`${this.name()}.error`));
            throw e;
        }
    }
    name() {
        return 'download_venso_control_document';
    }
    icon() {
        return 'file-arrow-down';
    }
}
